import { faCalendar } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';

import { useCheckLastUpdate } from '../../hooks/use-check-last-update';
import './styles.scss';

type checkLastUpdateProps = {
  lastUpdate: string;
};

export const CheckLastUpdatePortfolioPerformance = ({ lastUpdate = '' }: checkLastUpdateProps) => {
  const dateIsOld = useCheckLastUpdate(lastUpdate);

  return (
    <div className="portfolio-portfolio-last-update">
      <span>Last update:</span>
      <div className={`time-container ' ${dateIsOld ? 'old-time' : ''}`}>
        <FontAwesomeIcon icon={faCalendar} className="icon" />
        <span>
          {lastUpdate.length > 0 && moment.utc(lastUpdate).format('DD MMM YYYY - HH:mm') + ' UTC'}
        </span>
      </div>
    </div>
  );
};
